<div class="modal-header">
  <h5 class="modal-title">{{ options.title }} </h5>
</div>
<div class="modal-body">
  <p>{{ options.message }}</p>
  <div>
    <div class="d-flex pb-4">
      <div class="d-flex justify-content-center align-items-center" style="width: 32px; height: 32px">
        <sb-icon icon="search" class="icon-in-btn"></sb-icon>
      </div>
      <input
        class="form-control"
        [(ngModel)]="searchStr"
        placeholder="{{ 'lang.globals.searchPlaceholder' | translate }}">
    </div>
  </div>

  <div class="mydropdown">
    <ng-scrollbar style="height: 500px;">
      <button *ngFor="let option of options.values | filter : searchStr" class="dropdown-item"
              [ngClass]="getClass(option)" type="button" (click)="setSelectedOption(option)" (dblclick)="ok()">
        {{option.name ? option.name : option.value}}
      </button>
    </ng-scrollbar>
  </div>

</div>
<div class="modal-footer">
  <sb-button classes="btn-primary" (click)="ok()"
             [disabled]="!checkOkEnabled()">{{options.yes ? options.yes : 'lang.globals.ok' | translate }}
  </sb-button>
  <sb-button classes="btn-default" (click)="cancel()">{{options.no ? options.no : 'lang.globals.cancel' | translate }}
  </sb-button>
</div>
